module.exports = __webpack_public_path__ + "static/media/footer-background-mobile.dfc30774.svg";